import { CountUp } from 'countup.js';
import AOS from 'aos';
import mfp from "magnific-popup";
// Moment not included in frontend.js. Had to import.
import moment from 'moment';

function MarketingHome(config) {
    const VIDEOCU = "VIDEO";
    const VIEWSCU = "VIEWSCU";
    const FEEDBACKCU = "FEEDBACKCU";

    var MarketingHome = {

        tabInterval: null,
        tabShown: 1,
        numOfTabs: 0,
        isTabAutoScrolling: false,

        videosCountUp: null,
        videosAnimDuration: 3,
        videosValue: 131842,
        videosIncrementInit: false,
        // videoMaxValue: 99999,

        viewsCountUp: null,
        viewsAnimDuration: 3,
        rateIncreasePerWeek: 30000,
        startDateUnix: 1683468000, //8th of May 2023 0:00:00
        initialViewsValue: 21467551,
        // Calculation: (now - this week's monday) + initial views value + (weeks since startDateUnix * increaseViewsPerWeek)
        viewsValue: 21467551,
        // 1683760564 now

        viewsIncrementInit: false,
        // viewsMaxValue: 99999,

        feedbackCountUp: null,
        feedbackAnimDuration: 3,
        feedbackPercentage: 86.5,
        feedbackMaxValue: 85.9,
        feedbackMinValue: 80.6,
        feedbackIncrementInit: false,

        init: function (config){
            if (config)
            {
                Object.keys(config).forEach(function(key, value) {
                    MarketingHome[key] = config[key];
                });
            }
            
            this.initEventListeners();
            this.initCarousel();
            // this.initMfp();
            this.initCountUp();
            AOS.init({
                once: true
            });
            AOS.refreshHard();
        },
        initEventListeners: function() {
            $('body').on('click', ".scroll-to", function(event) {
                var hash = this.hash;
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function(){
                    window.location.hash = hash;
                });
                event.preventDefault();
                return false;
            });

            $("body").on("mouseover", ".solution-tab-container", function(e) {
                clearInterval(this.tabInterval);
            }.bind(this));

            $("body").on("mouseleave", ".solution-tab-container", function(e) {
                this.initTabAutoScroll();
            }.bind(this));

            $(window).on('resize scroll', function() {
                if(this.isInViewport(".solution-tab-container") && !this.isTabAutoScrolling)
                {
                    this.initTabAutoScroll();
                    this.isTabAutoScrolling = true;
                }
                else if (!this.isInViewport(".solution-tab-container"))
                {
                    clearInterval(this.tabInterval);
                    this.isTabAutoScrolling = false;
                }
            }.bind(this));
           
            $("body").on("click", ".video-card", function(e) {
                $("#video-card-popup").attr("src", $(e.currentTarget).data("url"));
                $("#videoPopupModal .modal-content").css("background-image", "url("+$(e.currentTarget).data('poster')+")")
                $("#videoPopupModal").modal('show');
                
            }.bind(this));

            $("#videoPopupModal").on("show.bs.modal", function(e) {
                $("#vmj-video-slider").slick("slickPause");
            });

            $("#videoPopupModal").on("hide.bs.modal", function(e) {
                $("#video-card-popup").attr("src", "");
                $("#vmj-video-slider").slick("slickPlay");
            });

            $("#videoPopupModal").on("hidden.bs.modal", function(e) {
                $("#videoPopupModal .modal-content").css("background-image", "none")
            });

            $("body").find(".solution-tab-container .nav-tabs .nav-item[data-toggle='tab']").on("shown.bs.tab", function(e) {
                switch (e.target.id){
                    case "nav-employer-branding-tab":{
                        $(".solutions-tabs").addClass("coral-radial");
                        $(".solutions-tabs").removeClass("blue-radial");
                        $(".solutions-tabs").removeClass("purple-radial");
                        break;
                    }
                    case "nav-talent-acquisition-tab":{
                        $(".solutions-tabs").removeClass("coral-radial");
                        $(".solutions-tabs").addClass("blue-radial");
                        $(".solutions-tabs").removeClass("purple-radial");
                         break;
                    }
                    case "nav-candidate-experience-tab":{
                        $(".solutions-tabs").removeClass("coral-radial");
                        $(".solutions-tabs").removeClass("blue-radial");
                        $(".solutions-tabs").addClass("purple-radial");
                            break;
                    }
                }
            });
        },
        // initMfp: function() {
        //     $("body").find(".js-learn-more").magnificPopup({type:'iframe'})
        // },
        // fetchIpLocation: function() {
        //     if (this._freeTrialCountries.includes(this._countryCode))
        //     {
        //         this.free_trial_active = true;
        //     }
            
        //     this.removeLoadingIndicator();
        // },
        removeLoadingIndicator: function() {
            // $("body").removeClass("prevent-scroll");
            $("body").find(".loading-section").addClass("d-none");
        },
        showLoadingIndicator: function() {
            // $("body").addClass("prevent-scroll");
            $("body").find(".loading-section").removeClass("d-none");
        },
        initCarousel: function() {
            $('#home-testimonials').slick({
                infinite: true,
                dots: true,
                arrows: true,
                prevArrow: '<button type="button" data-role="none" class="slick-prev ga-track" data-gaevent="Verbatim Prev Click" aria-label="next"><svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">\
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9 12.2903L4.5 7.57983L9 2.79807L6.78613 0.5L-3.09469e-07 7.57983L6.78612 14.5L9 12.2903Z" fill="#697378"/>\
                </svg></button>',
                nextArrow: '<button type="button" data-role="none" class="slick-next ga-track" data-gaevent="Verbatim Next Click" aria-label="next">\
                    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">\
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M-5.15372e-07 2.70967L4.5 7.42017L-1.00452e-07 12.2019L2.21387 14.5L9 7.42017L2.21387 0.499999L-5.15372e-07 2.70967Z" fill="#697378"/>\
                    </svg>\
                </button>',
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                focusOnSelect: true,
                pauseOnHover: true,
                autoplay: true,
                autoplaySpeed: 5000,
                responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: "30px"
                    }
                },
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
                ]
            });

            $('#home-testimonials').on('swipe', function(event, slick, direction){
                // left
                dataLayer.push(
                    {
                        'event': 'W-Verbatim-Slider-'+direction,
                    }
                )
              });

            $('#vmj-video-slider').slick({
                infinite: true,
                dots: false,
                arrows: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                initialSlide: 0,
                centerMode: true,
                centerPadding: '55px',
                focusOnSelect: true,
                pauseOnHover: true,
                autoplay: true,
                autoplaySpeed: 6000,
                cssEase: "linear",
                swipeToSlide: true,
                // adaptiveHeight: true,
                // variableWidth: true,
                responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '10%',
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '30px',
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '25%',
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: "22%"
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: "30px"
                    }
                },
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
                ]
            });
        },
        initTabAutoScroll: function() {
            this.numOfTabs = $("#nav-tab").children().length;
            this.tabInterval = setInterval(() => {
                this.tabShown++;
                $("#nav-tab :nth-child("+this.tabShown+")").tab('show');
                if (this.numOfTabs == this.tabShown)
                {
                    this.tabShown = 0;
                }
            }, 8000);
        },
        initCountUp: function() {
            this.initCountUpValues();
            this.videosCountUp = new CountUp('videos-created', this.videosValue, {
                enableScrollSpy: true,
                duration: this.videosAnimDuration,
                scrollSpyDelay: 500,
                scrollSpyOnce: true,
                useEasing: true,
                onCompleteCallback: function() {
                    if (!this.videosIncrementInit)
                    {
                        this.initIncrement(VIDEOCU);
                    }
                }.bind(this)
            });
            this.viewsCountUp = new CountUp('views', this.viewsValue, {
                enableScrollSpy: true,
                duration: this.viewsAnimDuration,
                scrollSpyDelay: 500,
                scrollSpyOnce: true,
                useEasing: true,
                onCompleteCallback: function() {
                    if (!this.viewsIncrementInit)
                    {
                        this.initIncrement(VIEWSCU);    
                    }
                    
                }.bind(this)
            });
            this.feedbackCountUp = new CountUp('positive-feedback', this.feedbackPercentage, { 
                enableScrollSpy: true,
                decimalPlaces: 1,
                duration: this.feedbackAnimDuration,
                suffix: "%",
                scrollSpyDelay: 500,
                scrollSpyOnce: true,
                useEasing: true,
                onCompleteCallback: function() {
                    if (!this.feedbackIncrementInit)
                    {
                        this.initIncrement(FEEDBACKCU);
                    }
                }.bind(this)
            });

            this.videosCountUp.start();
            this.viewsCountUp.start();
            this.feedbackCountUp.start();
        },
        initCountUpValues: function() {
            // Calculation: 4(now - this week's monday) + initial views value + (weeks since startDateUnix * increaseViewsPerWeek)
            var now = moment().unix();
            var mondayThisWeek = moment().weekday(1).startOf('day').unix();

            //#region Test
            //Sunday 14th
            //Monday 8th 0:00:00
            // var now = 1683986400;
            // var mondayThisWeek = 1683468000;

            //Monday 15th 12:00:00
            //Monday 15th 0:00:00
            // var now = 1684116000;
            // var mondayThisWeek = 1684072800;

            //Sunday 21st 
            //Monday 15th 0:00:00
            // var now = 1684591200;
            // var mondayThisWeek = 1684072800;
            //#endregion

            var weeksSinceStartDate = moment.unix(mondayThisWeek).diff(moment.unix(this.startDateUnix), 'week');

            this.viewsValue = (4 * (now - mondayThisWeek)) + this.initialViewsValue + (weeksSinceStartDate * this.rateIncreasePerWeek);
        },
        initIncrement: function(countUpType) {
            var interval = 0;
            var selectedCountUp = null;
            var increment = 1;
            
            switch (countUpType) {
                case VIDEOCU:
                    this.videosIncrementInit = true;
                    interval = 240000;
                    increment = 1;
                    selectedCountUp = new CountUp('videos-created', this.videosValue, {
                        startVal: this.videosValue,
                        useEasing: false,
                        duration: this.videosAnimDuration,
                    })
                    this.videosCountUp = selectedCountUp;
                    setInterval(() => {
                        this.videosValue = this.videosValue + increment;
                        selectedCountUp.update(this.videosValue);
                    }, interval);
                    break;
                case VIEWSCU:
                    this.viewsIncrementInit = true;
                    interval = 1000;
                    increment = 4;
                    selectedCountUp =  new CountUp('views', this.viewsValue, {
                        startVal: this.viewsValue,
                        duration: this.viewsAnimDuration,
                        useEasing: false,
                    })
                    this.viewsCountUp = selectedCountUp;
                    setInterval(() => {
                        this.viewsValue = this.viewsValue + increment;
                        selectedCountUp.update(this.viewsValue);
                    }, interval);
                    break;
                case FEEDBACKCU:
                    this.feedbackIncrementInit = true;
                    interval = 12000;
                    selectedCountUp = new CountUp('positive-feedback', this.feedbackPercentage, { 
                        startVal: this.feedbackPercentage,
                        decimalPlaces: 1,
                        duration: this.feedbackAnimDuration,
                        suffix: "%",
                        useEasing: false,
                    });
                    this.feedbackCountUp = selectedCountUp;
                    increment = 0.1;
                    setInterval(() => {
                        var randomNumber = Math.random();
                        if (this.feedbackPercentage == this.feedbackMaxValue)
                        {
                            this.feedbackPercentage = this.feedbackPercentage - increment;
                        }
                        else if (this.feedbackPercentage == this.feedbackMinValue)
                        {
                            this.feedbackPercentage = this.feedbackPercentage + increment;
                        }
                        else
                        {
                            if (randomNumber > 0.5)
                            {
                                this.feedbackPercentage = this.feedbackPercentage + increment;
                            }
                            else
                            {
                                this.feedbackPercentage = this.feedbackPercentage - increment;
                            }
                            
                        }
                        

                        selectedCountUp.update(this.feedbackPercentage);
                    }, interval);
                    break;
                default:
                    break;
            }
            selectedCountUp.useEasing = false;
        },
        isInViewport: function(element) {
            var elementTop = $(element).offset().top;
            var elementBottom = elementTop + $(element).outerHeight();
            var viewportTop = $(window).scrollTop();
            var viewportBottom = viewportTop + $(window).height();
            return elementBottom > viewportTop && elementTop < viewportBottom;
        }
    }

    // MarketingHome.init(config);
    return MarketingHome;
}

export {MarketingHome};